const configurationReducer = ( state = window.parent.ShopifyBotData.configuration ) => {
  return state;
};

export { configurationReducer };
